<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-15 14:45:07
 * @LastEditTime: 2019-08-20 17:30:16
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div v-if="$store.state.app.isPortrait" class="portrait-box">
    <el-carousel indicator-position="outside" class="swiper-block" :autoplay="false">
      <el-carousel-item v-for="(ele, j) in Object.values(dataPage)" :key="j+'i'" class="swiper-item">
        <!-- <span style="color:#fff;font-size: 30px;"> {{ j }}</span> -->
        <div class="portrait-content">
          <div v-for="(item) in ele" :key="item.poiId" class="portrait-item" @click="emitClick(item)">
            <div>
              <img class="img" :src="item.poiIcon && item.poiIcon.length < 20 ? `/images/icon-poi/${item.poiIcon}` : item.poiUrl ? item.poiUrl : '/images/icon-poi/general.png'" alt="">
              <div class="text">{{ item.poiName }}</div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
  <div v-else class="wrap-poi">
    <!-- 初始展示列表 -->
    <div v-if="!isShowMoreList" class="poiList">
      <div v-for="(item,i) in defaultData" :key="i" class="poiList__lis" @click="emitClick(item)">
        <img :src="item.poiIcon && item.poiIcon.length < 20 ? `/images/icon-poi/${item.poiIcon}` : item.poiUrl ? item.poiUrl : '/images/icon-poi/general.png'" alt="" class="poiList__img">
        <div class="poiList__text text-shadow">{{ item.poiName }}</div>
      </div>
      <!-- 更多按钮 -->
      <div v-if="data.length > 6" class="poiList__lis" @click="moreHandle">
        <img class="poiList__img" :class="isShowMoreList ? 'active' : ''" src="/images/preloader/icon_develop_01.png" alt="">
        <div class="poiList__text text-shadow">{{ isShowMoreList ? '隐藏更多' : '展开更多' }}</div>
      </div>
    </div>
    <!-- 更多列表 -->
    <div v-if="isShowMoreList" v-clickoutside="outsideClose" class="more-list">
      <div class="content">
        <div v-for="(item,i) in dataPage[curPageIndex]" :key="i" class="lis" @click="emitClick(item)">
          <img :src="item.poiIcon && item.poiIcon.length < 20 ? `/images/icon-poi/${item.poiIcon}` : item.poiUrl ? item.poiUrl : '/images/icon-poi/general.png'" alt="" class="img">
          <div class="text">{{ item.poiName }}</div>
        </div>
      </div>
      <!-- 分页按钮 -->
      <div class="btn-group">
        <template v-if="pageTotal > 1">
          <div class="btn" :class="curPageIndex === 1 ? 'prev1' : 'prev2'" @click="prevHandle"></div>
          <div class="text">{{ curPageIndex + ' / ' + pageTotal }}</div>
          <div class="btn" :class="curPageIndex === pageTotal ? 'next1' : 'next2'" @click="nextHandle"></div>
        </template>

        <div class="more-btn" @click="moreHandle">
          <img class="poiList__img" :class="isShowMoreList ? 'active' : ''" src="/images/preloader/icon_develop_01.png" alt="">
          <div class="poiList__text text-shadow">{{ isShowMoreList ? '隐藏更多' : '展开更多' }}</div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  components: {
  },
  directives: {
    clickoutside: {
      bind (el, binding, vnode) {
        function documentHandler (e) {
          if (el.contains(e.target)) {
            return false;
          }
          if (binding.expression) {
            binding.value(e);
          }
        }

        function KeyUp (e) {
          if (e.keyCode === 27) {
            if (binding.expression) {
              binding.value(e);
            }
          }
        }
        el.__vueClickOutSize__ = documentHandler;
        el.__vueKeyup__ = KeyUp;

        document.addEventListener('keyup', KeyUp);
        document.addEventListener('click', documentHandler);
      },
      unbind (el, binding) {
        document.removeEventListener('click', el.__vueClickOutSize__);
        delete el.__vueClickOutSize__;

        document.removeEventListener('keyup', el.__vueKeyup__);
        delete el.__vueKeyup__;
      }
    }
  },
  props: {
    // 分类数据
    data: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      curPageIndex: 1, // 当前页数
      limit: 14, // 每页总数
      isShowMoreList: false, // 是否显示更多列表
      clickState: true
    };
  },
  computed: {
    // 默认展示数据，6个
    defaultData () {
      let arr = this.data.filter((item, index) => {
        return index < 6;
      });
      return arr;
    },
    // 数据分页
    dataPage () {
      let obj = {};
      let i = 1;
      this.data.forEach((item, index) => {
        if (index / this.limit >= i) {
          i++;
        }
        if (obj.hasOwnProperty(i)) {
          obj[i].push(item);
        } else {
          obj[i] = [item];
        }
      });
      console.log(this.data);
      console.log(obj);
      console.log(123123123)
      return obj;
    },
    pageTotal () {
      return Math.ceil(this.data.length / this.limit);
    }
  },
  watch: {
  },
  created () {
    if (this.$store.state.app.isPortrait) {
      this.limit = 8;
    }
  },
  methods: {
    // 点击外部关闭
    outsideClose () {
      this.isShowMoreList = false;
    },
    // 点击poi
    emitClick (data) {
      console.log('当前点击POI数据：', data);
      if (!this.clickState) { return ; }
      this.clickState = false;
      setTimeout(() => {
        this.clickState = true;
      }, 1000);
      this.isShowMoreList = false;
      this.$emit('clickItem', data);
    },
    // 上一页
    prevHandle () {
      if (this.curPageIndex > 1) {
        this.curPageIndex--;
      }
    },
    // 下一页
    nextHandle () {
      if (this.curPageIndex < this.pageTotal) {
        this.curPageIndex++;
      }
    },
    // 更多
    moreHandle (e) {
      e.stopPropagation();// 阻止事件冒泡
      this.isShowMoreList = !this.isShowMoreList;
    }
  }
};
</script>

<style lang="scss" scoped>

@media (orientation: landscape) {
  /*横屏 css*/
.wrap-poi {
  position: relative;
  display: flex;
  align-items: center;
  .poiList {
    position: relative;
    display: flex;
    text-align: center;
    padding-left: 20px;
    &__lis {
      text-align: center;
      width: 90px;
      // margin-left: 30px;
      padding: 20px 0;
    }
    &__img {
      width: 60px;
      height: 60px;
      border-radius: 44px;
      transform: rotate(0);
      transition: 300ms;
    }
    &__img.active {
      transform: rotate(180deg);
    }
    &__text {
      font-size: 18px;
      margin: 10px 0 0 0;
      color: $color-white;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .more {
    padding: 20px 15px;
    height: 100px;
    // width: 100px;
    color: $color-white;
    .text {
      margin: 10px 0 0 0;
      font-size: 18px;
    }
    img {
      width: 60px;
      transform: rotate(0);
      transition: 300ms;
    }
  }
  .more-list {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 670px;
    box-sizing: border-box;
    padding: 20px;
    // background: url("/images/preloader/rect1.png") no-repeat;
    background: rgba(0,0,0,0.4);
    background-size: 100%;
    border-radius: 8px;
    .content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .lis {
        height: 120px;
        width: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .img {
        width: 60px;
        height: 60px;
        border-radius: 30px;
      }
      .text {
        font-size: 20px;
        margin-top: 10px;
        color: #eee;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
      }
    }
    .btn-group {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      height: 60px;
      margin-top: 20px;
      .text{
        font-size: 20px;
        color: $color-white;
        margin: 0 20px;
      }
      .btn {
        width: 126px;
        height: 58px;
      }
      .prev1{
        background: url("/images/preloader/prevPage1.png") no-repeat;
      }
      .prev2{
        background: url("/images/preloader/prevPage2.png") no-repeat;
      }
      .next1{
        background: url("/images/preloader/nextPage1.png") no-repeat;
      }
      .next2{
        background: url("/images/preloader/nextPage2.png") no-repeat;
      }
    }
  }
  .more-btn{
    position: absolute;
    right: 0px;
    bottom: 0;
  }
}
}

@media (orientation: portrait) {
  .portrait-box{
    width: 100%;
    height: 100%;
    background-color: $color-opacity-primary;
    border-radius: 1.48vw;
    padding: 2.96vw;
    box-sizing: border-box;
    .portrait-content{
      width: 100%;
      height: 100%;
      display: grid;
      grid-gap: 3.7vw;
      grid-template-columns: repeat(4, 9.63vw);
    }
    .portrait-item{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 9.63vw;
      height: fit-content;
    }
    .img{
      width: 100%;
    }
    .text{
      margin-top: 1.48vw;
      color: #fff;
      font-size: 2.22vw;
    }
    .swiper-block{
      width: 100%;
      height: 100%;
    }
  }
}
.portrait-box ::v-deep .el-carousel__container {
  height: 90%;
}
</style>

